import { Typography } from '@mui/material'
import React from 'react'
import { useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { BackButton } from '../components/BackButton'
import ContactCard from '../components/ContactCard'
import { PageContainer } from '../components/layout/PageContainer'
import YesNoAction from '../components/YesNoAction'
import { selectAllFarmerAccounts, selectContactInfo } from '../features/azure-b2c/storage'
import { TestIds } from '../testIds'
import { selectSalesAgreementById } from '../features/sales-agreements/storage'

export const DrawdownSuccess = () => {
  const params = useParams()

  const salesAgreementId = params.salesAgreementId
  const salesAgreement = useSelector(selectSalesAgreementById(salesAgreementId))
  const farmlandsAccounts = useSelector(selectAllFarmerAccounts)
  const navigate = useNavigate()

  const relationshipOwner = useSelector(selectContactInfo)

  if (!salesAgreement) {
    navigate('/agreements')
  }

  return (
    <PageContainer data-testid={TestIds.pages.drawdownSuccess}>
      <BackButton text='Back to Sales Agreement' onClick={() => navigate(-1)} />
      <YesNoAction
        display='DELIVERY RELEASE REQUESTED'
        subheading={
          <Typography variant='h4' sx={{ mt: 4, mb: 2 }}>
            Thanks {farmlandsAccounts?.contactFirstName}!
          </Typography>
        }
        body={
          <Typography variant='body2'>
            Your request to release delivery for {salesAgreement?.title} has been submitted. You
            will receive an email confirming your request details.
          </Typography>
        }
      />
      <ContactCard
        sx={{ mt: 4 }}
        title='If you have any questions please contact your Farmlands representative.'
        data-testid={TestIds.components.contactCard.card}
        {...relationshipOwner}
      />
    </PageContainer>
  )
}
